// extracted by mini-css-extract-plugin
export var buttonContent = "_3t-0";
export var centered = "_3t-1";
export var centeredFlex = "_3t-2";
export var errorText = "_3t-3";
export var icon = "_3t-4";
export var iconButtonContent = "_3t-5";
export var monospace = "_3t-6";
export var padded = "_3t-7";